import React, { Component } from 'react';

export default class PaginatedList extends Component {
  state = {
    isLoading: false,
  };

  handleScroll = () => {
    const { canLoadMore, onLoadMore } = this.props;
    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer;

    if (canLoadMore && scrollHeight - scrollTop - clientHeight < 200) {
      this.setState({ isLoading: true });
      onLoadMore(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  renderLoading() {
    if (this.state.isLoading) {
      return <div className="lds-dual-ring"></div>;
    } else {
      return null;
    }
  }

  render() {
    return (
      <div
        className="scroll-container"
        onScroll={this.handleScroll}
        ref={(container) => {
          this.scrollContainer = container;
        }}
      >
        {this.props.children}
        {this.renderLoading()}
      </div>
    );
  }
}
